import { Link } from "react-router-dom";

/** Desktop support sidebar (opened via .head-pro in header). Hidden on tablet/phone. */
const ContactExpert = () => {
  return (
    <div className="menu-pop menu-pop2" aria-hidden="true">
      <span className="menu-pop-clo" role="button" tabIndex={0} aria-label="Close">
        <i className="fa fa-times" aria-hidden="true"></i>
      </span>

      <div className="inn">
        <div className="menu-pop-help">
          <h4>Help &amp; Support</h4>
          <div className="user-bio">
            <p>Reach our Raipur support team for profile help or match guidance.</p>
            <a href="tel:+919806863659" className="btn btn-primary btn-sm">
              <i className="fa fa-phone" aria-hidden="true"></i> +91 98068 63659
            </a>
            <a
              href="https://wa.me/919806863659"
              className="btn btn-primary btn-sm"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: 8 }}
            >
              <i className="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp
            </a>
            <Link to="/contact" className="btn btn-primary btn-sm" style={{ marginTop: 8 }}>
              Contact page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactExpert;
